/**
 * @title: xss过滤规则
 * @params: 传参
 *   - <Sring> {content} 标签字符串，必填
 *   - <Object> {options} 自定义规则，非必填
 * @des: 自定义规则参考 https://github.com/leizongmin/js-xss/blob/master/README.zh.md
 */
import xss from 'xss';
const defaultRule = {
    whiteList: {
        a: ["href", "title", "target", "style", "class"],
        img: ["src", "alt", "style", "class"],
        video: ["src", "controls", "poster", "autoplay", "preload", "width", "height", "loop", "style", "class"],
        audio: ["src", "controls", "autoplay", "preload", "loop", "style", "class"],
        div: ["style", "class"],
        p: ["style", "class"],
        ul: ["style", "class"],
        ol: ["style", "class"],
        li: ["style", "class"],
        span: ["style", "class"],
        h1: ["style", "class"],
        h2: ["style", "class"],
        h3: ["style", "class"],
        h4: ["style", "class"],
        h5: ["style", "class"],
        h6: ["style", "class"],
        table: ["style", "class"],
        thead: ["style", "class"],
        tbody: ["style", "class"],
        col: ["style", "class"],
        colgroup: ["style", "class"],
        tr: ["style", "class"],
        td: ["style", "class"],
        br: ["style", "class"],
        i: ["style", "class"],
        em: ["style", "class"],
        strong: ["style", "class"],
        b: ["style", "class"],
        del: ["style", "class"],
        u: ["style", "class"],
        sub: ["style", "class"],
        sup: ["style", "class"],
        s: ["style", "class"],
        pre: ["style", "class"],
        blockquote: ["style", "class"],
    },
    stripIgnoreTagBody: true,
    onTagAttr(tag, name, value, isWhiteAttr) {
        if (tag == 'img' && name == 'src') {
            if (!checkImage(value)) {
                return ''
            }
        }
        if (name.substr(0, 5) === "data-") {
            return name + '="' + xss.escapeAttrValue(value) + '"';
        }
    }
}

function checkImage(url) {
    const index= url.lastIndexOf('.');
    const ext = url.substr(index+1);
    const suffix = ['png', 'jpg', 'jpeg', 'gif', 'webp'];
    if (/(f[234]|(f2)|i1s|f12stag)\.kkmh\.com/.test(url)) {
        return true;
    }
    return suffix.indexOf(ext.toLowerCase()) !== -1;
}

export default function(content, options = {}) {
    return xss(content, Object.assign({}, defaultRule, options))
};